import {
    spawn
} from 'redux-saga/effects';
import {
    PROPOSE_SESSION,
    START_SESSION,
    ON_SESSION,
    FINISH_SESSION,
    LEVEL_UP,
    REPEAT_LEVEL,
    DISPATCH_INTERACTION,
    DISPATCH_CURIOSITY
} from './gameSaga';
import { GET_QUESTIONS } from './questionSaga';
import { USER_UPDATE_LOCAL_DATA, AUTH_LOGOUT_USER, USER_UPDATE_REMOTE_DATA, RESTART_GAME } from './userSaga';
import { GET_DASHBOARD, GET_SCHOOLS, GET_COURSES, GET_MISSIONS } from './fetchSaga';
import { DISPATCH_MISSION } from './missionSaga';
import { S_APP_STARTED, S_APP_REDIRECT } from './appSaga';
import { ACCEPT_SESSION, SAVE_SESSION } from './sessionSaga';
import { GET_CURIOSITY } from './curiositySaga';
import { TIMER } from './timeSaga';
import {DISPATCH_OPENNOTIFICATION} from './notificationSaga';

export default function * rootSaga () {
    yield [
        // App
        spawn(S_APP_STARTED),

        // Notification
        spawn(DISPATCH_OPENNOTIFICATION),

        // Game
        spawn(PROPOSE_SESSION),
        spawn(ACCEPT_SESSION),
        spawn(START_SESSION),
        spawn(ON_SESSION),
        spawn(FINISH_SESSION),
        spawn(LEVEL_UP),
        spawn(DISPATCH_INTERACTION),
        spawn(DISPATCH_CURIOSITY),
        spawn(DISPATCH_MISSION),
        spawn(SAVE_SESSION),
        spawn(REPEAT_LEVEL),
        spawn(TIMER),

        // USER
        spawn(S_APP_REDIRECT),
        spawn(AUTH_LOGOUT_USER),
        spawn(RESTART_GAME),

        spawn(USER_UPDATE_LOCAL_DATA),
        spawn(USER_UPDATE_REMOTE_DATA),

        // General Gets
        spawn(GET_QUESTIONS),
        spawn(GET_CURIOSITY),
        spawn(GET_DASHBOARD),
        spawn(GET_COURSES),
        spawn(GET_SCHOOLS),
        spawn(GET_MISSIONS)
    ];
}



// WEBPACK FOOTER //
// ./src/sagas/saga.js